/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum SkillGroup {
  Activities_Copyrights = "Activities_Copyrights",
  Activities_Trademarks = "Activities_Trademarks",
  PatentActivities_Patents = "PatentActivities_Patents",
  PatentType_Patents = "PatentType_Patents",
  Activities_BankruptcyAndReorganization = "Activities_BankruptcyAndReorganization",
  BankruptcyType_BankruptcyAndReorganization = "BankruptcyType_BankruptcyAndReorganization",
  Activities_DebtCapitalMarkets = "Activities_DebtCapitalMarkets",
  IssuanceType_DebtCapitalMarkets = "IssuanceType_DebtCapitalMarkets",
  ProductType_DebtCapitalMarkets = "ProductType_DebtCapitalMarkets",
  RegulatoryExpertise_DebtCapitalMarkets = "RegulatoryExpertise_DebtCapitalMarkets",
  Activities_EquityCapitalMarkets = "Activities_EquityCapitalMarkets",
  ProductType_EquityCapitalMarkets = "ProductType_EquityCapitalMarkets",
  RegulatoryExpertise_EquityCapitalMarkets = "RegulatoryExpertise_EquityCapitalMarkets",
  AreaOfExpertise_AdvertisingTechnology = "AreaOfExpertise_AdvertisingTechnology",
  Activities_ProcurementAndOutsourcing = "Activities_ProcurementAndOutsourcing",
  Expertise_ProductCounsel = "Expertise_ProductCounsel",
  AgreementTypes_SupplyChainTransportation = "AgreementTypes_SupplyChainTransportation",
  Expertise_SupplyChainTransportation = "Expertise_SupplyChainTransportation",
  Activities_SupplyChainTransportation = "Activities_SupplyChainTransportation",
  Activities_MarketingAndAdvertising = "Activities_MarketingAndAdvertising",
  AgreementTypes_MarketingAndAdvertising = "AgreementTypes_MarketingAndAdvertising",
  RegulatoryExpertise_MarketingAndAdvertising = "RegulatoryExpertise_MarketingAndAdvertising",
  Activities_ClinicalTrials = "Activities_ClinicalTrials",
  AgreementTypes_ClinicalTrials = "AgreementTypes_ClinicalTrials",
  AgreementTypes_CloudSaaSSoftwareLicensing = "AgreementTypes_CloudSaaSSoftwareLicensing",
  Expertise_CloudSaaSSoftwareLicensing = "Expertise_CloudSaaSSoftwareLicensing",
  IndustryExperience_CloudSaaSSoftwareLicensing = "IndustryExperience_CloudSaaSSoftwareLicensing",
  ContractActivities_CommercialContracts = "ContractActivities_CommercialContracts",
  ContractTypes_CommercialContracts = "ContractTypes_CommercialContracts",
  AreaOfExpertise_EnergyNuclear = "AreaOfExpertise_EnergyNuclear",
  RegulatoryExpertise_EnergyOilAndGas = "RegulatoryExpertise_EnergyOilAndGas",
  Activities_EnergyOilAndGas = "Activities_EnergyOilAndGas",
  EnergyType_EnergyOilAndGas = "EnergyType_EnergyOilAndGas",
  OperationsType_EnergyOilAndGas = "OperationsType_EnergyOilAndGas",
  Activities_EnergyRenewable = "Activities_EnergyRenewable",
  EnergyType_EnergyRenewable = "EnergyType_EnergyRenewable",
  RegulatoryExpertise_EnergyRenewable = "RegulatoryExpertise_EnergyRenewable",
  Scale_EnergyRenewable = "Scale_EnergyRenewable",
  Activities_GovernmentContracts = "Activities_GovernmentContracts",
  LevelOfGovernment_GovernmentContracts = "LevelOfGovernment_GovernmentContracts",
  RegulatoryExpertise_GovernmentContracts = "RegulatoryExpertise_GovernmentContracts",
  Activities_CorporateSecretaryAndServices = "Activities_CorporateSecretaryAndServices",
  Expertise_CorporateSecretaryAndServices = "Expertise_CorporateSecretaryAndServices",
  PrivacyActivities_DataPrivacy = "PrivacyActivities_DataPrivacy",
  PrivacyContracts_DataPrivacy = "PrivacyContracts_DataPrivacy",
  PrivacyLaws_DataPrivacy = "PrivacyLaws_DataPrivacy",
  CybersecurityActivities_Cybersecurity = "CybersecurityActivities_Cybersecurity",
  AssetCategories_AssetFinanceAndLeasing = "AssetCategories_AssetFinanceAndLeasing",
  ProductType_FinTechAndPayments = "ProductType_FinTechAndPayments",
  RegulatoryExpertise_FinTechAndPayments = "RegulatoryExpertise_FinTechAndPayments",
  Activities_StructuredAndProjectFinance = "Activities_StructuredAndProjectFinance",
  Expertise_StructuredAndProjectFinance = "Expertise_StructuredAndProjectFinance",
  Activities_RealEstateFinance = "Activities_RealEstateFinance",
  Expertise_RealEstateFinance = "Expertise_RealEstateFinance",
  Activities_InvestmentComplianceAndMarketAccess = "Activities_InvestmentComplianceAndMarketAccess",
  Activities_CommercialBanking = "Activities_CommercialBanking",
  ProductType_ConsumerBankingAndLending = "ProductType_ConsumerBankingAndLending",
  RegulatoryExpertise_ConsumerBankingAndLending = "RegulatoryExpertise_ConsumerBankingAndLending",
  Activities_CorporateTrustsLendingAndBorrowing = "Activities_CorporateTrustsLendingAndBorrowing",
  ProductType_CorporateTrustsLendingAndBorrowing = "ProductType_CorporateTrustsLendingAndBorrowing",
  RegulatoryExpertise_CorporateTrustsLendingAndBorrowing = "RegulatoryExpertise_CorporateTrustsLendingAndBorrowing",
  Activities_Derivatives = "Activities_Derivatives",
  ProductType_Derivatives = "ProductType_Derivatives",
  RegulatoryExpertise_Derivatives = "RegulatoryExpertise_Derivatives",
  Activities_SecuritiesAndPrimeBrokerage = "Activities_SecuritiesAndPrimeBrokerage",
  FundType_SecuritiesAndPrimeBrokerage = "FundType_SecuritiesAndPrimeBrokerage",
  Activities_InvestmentAndWealthManagement = "Activities_InvestmentAndWealthManagement",
  ClientType_InvestmentAndWealthManagement = "ClientType_InvestmentAndWealthManagement",
  RegulatoryExpertise_InvestmentAndWealthManagement = "RegulatoryExpertise_InvestmentAndWealthManagement",
  Activities_Insurance = "Activities_Insurance",
  ProductType_Insurance = "ProductType_Insurance",
  RegulatoryExpertise_Insurance = "RegulatoryExpertise_Insurance",
  Expertise_ERISACompensationPensionsAndBenefits = "Expertise_ERISACompensationPensionsAndBenefits",
  Expertise_EmployeeInvestigations = "Expertise_EmployeeInvestigations",
  Expertise_GeneralEmployment = "Expertise_GeneralEmployment",
  Activities_LaborRelations = "Activities_LaborRelations",
  Activities_LegalOperations = "Activities_LegalOperations",
  Activities_AlternativeDisputeResolution = "Activities_AlternativeDisputeResolution",
  TypesOfDisputes_AlternativeDisputeResolution = "TypesOfDisputes_AlternativeDisputeResolution",
  Activities_Litigation = "Activities_Litigation",
  TypesOfDisputes_Litigation = "TypesOfDisputes_Litigation",
  LitigationRole_Litigation = "LitigationRole_Litigation",
  LitigationActivities_IntellectualPropertyLitigation = "LitigationActivities_IntellectualPropertyLitigation",
  Activities_MAndADivestitures = "Activities_MAndADivestitures",
  MAndAAdvisory_MAndADivestitures = "MAndAAdvisory_MAndADivestitures",
  TransactionType_MAndADivestitures = "TransactionType_MAndADivestitures",
  Activities_CommercialRealEstateAndLeasing = "Activities_CommercialRealEstateAndLeasing",
  Activities_ConstructionPlanningAndDevelopment = "Activities_ConstructionPlanningAndDevelopment",
  RegulatoryExpertise_AntitrustAndCompetition = "RegulatoryExpertise_AntitrustAndCompetition",
  RegulatoryExpertise_BriberyAndCorruption = "RegulatoryExpertise_BriberyAndCorruption",
  Activities_BriberyAndCorruption = "Activities_BriberyAndCorruption",
  RegulatoryExpertise_ConsumerProtectionRegulation = "RegulatoryExpertise_ConsumerProtectionRegulation",
  RegulatoryExpertise_EnergyRegulationAndCompliance = "RegulatoryExpertise_EnergyRegulationAndCompliance",
  Activities_EnvironmentalSocialAndGovernanceCompliance = "Activities_EnvironmentalSocialAndGovernanceCompliance",
  RegulatoryExpertise_EnvironmentalSocialAndGovernanceCompliance = "RegulatoryExpertise_EnvironmentalSocialAndGovernanceCompliance",
  Activities_FinancialServicesComplianceAndRegulation = "Activities_FinancialServicesComplianceAndRegulation",
  RegulatoryExpertise_FinancialServicesComplianceAndRegulation = "RegulatoryExpertise_FinancialServicesComplianceAndRegulation",
  Activities_TradeComplianceSanctionsAndExportControls = "Activities_TradeComplianceSanctionsAndExportControls",
  RegulatoryExpertise_TradeComplianceSanctionsAndExportControls = "RegulatoryExpertise_TradeComplianceSanctionsAndExportControls",
  WorkFocus_TradeComplianceSanctionsAndExportControls = "WorkFocus_TradeComplianceSanctionsAndExportControls",
  Support_Tax = "Support_Tax",
  Activities_GeneralCounselServices = "Activities_GeneralCounselServices",
  Activities_ArtificialIntelligence = "Activities_ArtificialIntelligence",
  Activities_LifeSciencesCompliance = "Activities_LifeSciencesCompliance",
  Expertise_LifeSciencesMarketAccess = "Expertise_LifeSciencesMarketAccess",
  Expertise_LifeSciencesSupplyChain = "Expertise_LifeSciencesSupplyChain",
  Activities_EnergyUtilities = "Activities_EnergyUtilities",
  Expertise_EnergyUtilities = "Expertise_EnergyUtilities",
  Expertise_LifeSciencesRegulatory = "Expertise_LifeSciencesRegulatory",
  Expertise_HealthcareRegulatoryAndCompliance = "Expertise_HealthcareRegulatoryAndCompliance",
  Activities_IPLicensing = "Activities_IPLicensing",
  IPType_IPLicensing = "IPType_IPLicensing",
  Activities_InvestigationsAndEnforcement = "Activities_InvestigationsAndEnforcement",
}

export const SkillGroupDisplay: Record<SkillGroup, string> = {
  [SkillGroup.Activities_Copyrights]: "Activities",
  [SkillGroup.Activities_Trademarks]: "Activities",
  [SkillGroup.PatentActivities_Patents]: "Patent Activities",
  [SkillGroup.PatentType_Patents]: "Patent Type",
  [SkillGroup.Activities_BankruptcyAndReorganization]: "Activities",
  [SkillGroup.BankruptcyType_BankruptcyAndReorganization]: "Bankruptcy Type",
  [SkillGroup.Activities_DebtCapitalMarkets]: "Activities",
  [SkillGroup.IssuanceType_DebtCapitalMarkets]: "Issuance Type",
  [SkillGroup.ProductType_DebtCapitalMarkets]: "Product Type",
  [SkillGroup.RegulatoryExpertise_DebtCapitalMarkets]: "Regulatory Expertise",
  [SkillGroup.Activities_EquityCapitalMarkets]: "Activities",
  [SkillGroup.ProductType_EquityCapitalMarkets]: "Product Type",
  [SkillGroup.RegulatoryExpertise_EquityCapitalMarkets]: "Regulatory Expertise",
  [SkillGroup.AreaOfExpertise_AdvertisingTechnology]: "Area of Expertise",
  [SkillGroup.Activities_ProcurementAndOutsourcing]: "Activities",
  [SkillGroup.Expertise_ProductCounsel]: "Expertise",
  [SkillGroup.AgreementTypes_SupplyChainTransportation]: "Agreement Types",
  [SkillGroup.Expertise_SupplyChainTransportation]: "Expertise",
  [SkillGroup.Activities_SupplyChainTransportation]: "Activities",
  [SkillGroup.Activities_MarketingAndAdvertising]: "Activities",
  [SkillGroup.AgreementTypes_MarketingAndAdvertising]: "Agreement Types",
  [SkillGroup.RegulatoryExpertise_MarketingAndAdvertising]: "Regulatory Expertise",
  [SkillGroup.Activities_ClinicalTrials]: "Activities",
  [SkillGroup.AgreementTypes_ClinicalTrials]: "Agreement Types",
  [SkillGroup.AgreementTypes_CloudSaaSSoftwareLicensing]: "Agreement Types",
  [SkillGroup.Expertise_CloudSaaSSoftwareLicensing]: "Expertise",
  [SkillGroup.IndustryExperience_CloudSaaSSoftwareLicensing]: "Industry Experience",
  [SkillGroup.ContractActivities_CommercialContracts]: "Contract Activities",
  [SkillGroup.ContractTypes_CommercialContracts]: "Contract Types",
  [SkillGroup.AreaOfExpertise_EnergyNuclear]: "Area of Expertise",
  [SkillGroup.RegulatoryExpertise_EnergyOilAndGas]: "Regulatory Expertise",
  [SkillGroup.Activities_EnergyOilAndGas]: "Activities",
  [SkillGroup.EnergyType_EnergyOilAndGas]: "Energy Type",
  [SkillGroup.OperationsType_EnergyOilAndGas]: "Operations Type",
  [SkillGroup.Activities_EnergyRenewable]: "Activities",
  [SkillGroup.EnergyType_EnergyRenewable]: "Energy Type",
  [SkillGroup.RegulatoryExpertise_EnergyRenewable]: "Regulatory Expertise",
  [SkillGroup.Scale_EnergyRenewable]: "Scale",
  [SkillGroup.Activities_GovernmentContracts]: "Activities",
  [SkillGroup.LevelOfGovernment_GovernmentContracts]: "Level of Government",
  [SkillGroup.RegulatoryExpertise_GovernmentContracts]: "Regulatory Expertise",
  [SkillGroup.Activities_CorporateSecretaryAndServices]: "Activities",
  [SkillGroup.Expertise_CorporateSecretaryAndServices]: "Expertise",
  [SkillGroup.PrivacyActivities_DataPrivacy]: "Privacy Activities",
  [SkillGroup.PrivacyContracts_DataPrivacy]: "Privacy Contracts",
  [SkillGroup.PrivacyLaws_DataPrivacy]: "Privacy Laws",
  [SkillGroup.CybersecurityActivities_Cybersecurity]: "Cybersecurity Activities",
  [SkillGroup.AssetCategories_AssetFinanceAndLeasing]: "Asset Categories",
  [SkillGroup.ProductType_FinTechAndPayments]: "Product Type",
  [SkillGroup.RegulatoryExpertise_FinTechAndPayments]: "Regulatory Expertise",
  [SkillGroup.Activities_StructuredAndProjectFinance]: "Activities",
  [SkillGroup.Expertise_StructuredAndProjectFinance]: "Expertise",
  [SkillGroup.Activities_RealEstateFinance]: "Activities",
  [SkillGroup.Expertise_RealEstateFinance]: "Expertise",
  [SkillGroup.Activities_InvestmentComplianceAndMarketAccess]: "Activities",
  [SkillGroup.Activities_CommercialBanking]: "Activities",
  [SkillGroup.ProductType_ConsumerBankingAndLending]: "Product Type",
  [SkillGroup.RegulatoryExpertise_ConsumerBankingAndLending]: "Regulatory Expertise",
  [SkillGroup.Activities_CorporateTrustsLendingAndBorrowing]: "Activities",
  [SkillGroup.ProductType_CorporateTrustsLendingAndBorrowing]: "Product Type",
  [SkillGroup.RegulatoryExpertise_CorporateTrustsLendingAndBorrowing]: "Regulatory Expertise",
  [SkillGroup.Activities_Derivatives]: "Activities",
  [SkillGroup.ProductType_Derivatives]: "Product Type",
  [SkillGroup.RegulatoryExpertise_Derivatives]: "Regulatory Expertise",
  [SkillGroup.Activities_SecuritiesAndPrimeBrokerage]: "Activities",
  [SkillGroup.FundType_SecuritiesAndPrimeBrokerage]: "Fund Type",
  [SkillGroup.Activities_InvestmentAndWealthManagement]: "Activities",
  [SkillGroup.ClientType_InvestmentAndWealthManagement]: "Client Type",
  [SkillGroup.RegulatoryExpertise_InvestmentAndWealthManagement]: "Regulatory Expertise",
  [SkillGroup.Activities_Insurance]: "Activities",
  [SkillGroup.ProductType_Insurance]: "Product Type",
  [SkillGroup.RegulatoryExpertise_Insurance]: "Regulatory Expertise",
  [SkillGroup.Expertise_ERISACompensationPensionsAndBenefits]: "Expertise",
  [SkillGroup.Expertise_EmployeeInvestigations]: "Expertise",
  [SkillGroup.Expertise_GeneralEmployment]: "Expertise",
  [SkillGroup.Activities_LaborRelations]: "Activities",
  [SkillGroup.Activities_LegalOperations]: "Activities",
  [SkillGroup.Activities_AlternativeDisputeResolution]: "Activities",
  [SkillGroup.TypesOfDisputes_AlternativeDisputeResolution]: "Types of Disputes",
  [SkillGroup.Activities_Litigation]: "Types of Disputes",
  [SkillGroup.TypesOfDisputes_Litigation]: "Types of Disputes",
  [SkillGroup.LitigationRole_Litigation]: "Types of Disputes",
  [SkillGroup.LitigationActivities_IntellectualPropertyLitigation]: "Litigation Activities",
  [SkillGroup.Activities_MAndADivestitures]: "Activities",
  [SkillGroup.MAndAAdvisory_MAndADivestitures]: "M&A Advisory",
  [SkillGroup.TransactionType_MAndADivestitures]: "Transaction Type",
  [SkillGroup.Activities_CommercialRealEstateAndLeasing]: "Activities",
  [SkillGroup.Activities_ConstructionPlanningAndDevelopment]: "Activities",
  [SkillGroup.RegulatoryExpertise_AntitrustAndCompetition]: "Expertise",
  [SkillGroup.RegulatoryExpertise_BriberyAndCorruption]: "Regulatory Expertise",
  [SkillGroup.Activities_BriberyAndCorruption]: "Activities",
  [SkillGroup.RegulatoryExpertise_ConsumerProtectionRegulation]: "Regulatory Expertise",
  [SkillGroup.RegulatoryExpertise_EnergyRegulationAndCompliance]: "Regulatory Expertise",
  [SkillGroup.Activities_EnvironmentalSocialAndGovernanceCompliance]: "Activities",
  [SkillGroup.RegulatoryExpertise_EnvironmentalSocialAndGovernanceCompliance]: "Regulatory Expertise",
  [SkillGroup.Activities_FinancialServicesComplianceAndRegulation]: "Activities",
  [SkillGroup.RegulatoryExpertise_FinancialServicesComplianceAndRegulation]: "Regulatory Expertise",
  [SkillGroup.Activities_TradeComplianceSanctionsAndExportControls]: "Activities",
  [SkillGroup.RegulatoryExpertise_TradeComplianceSanctionsAndExportControls]: "Regulatory Expertise",
  [SkillGroup.WorkFocus_TradeComplianceSanctionsAndExportControls]: "Focus",
  [SkillGroup.Support_Tax]: "Support",
  [SkillGroup.Activities_GeneralCounselServices]: "Activities",
  [SkillGroup.Activities_ArtificialIntelligence]: "Activities",
  [SkillGroup.Activities_LifeSciencesCompliance]: "Activities",
  [SkillGroup.Expertise_LifeSciencesMarketAccess]: "Expertise",
  [SkillGroup.Expertise_LifeSciencesSupplyChain]: "Expertise",
  [SkillGroup.Activities_EnergyUtilities]: "Activities",
  [SkillGroup.Expertise_EnergyUtilities]: "Expertise",
  [SkillGroup.Expertise_LifeSciencesRegulatory]: "Expertise",
  [SkillGroup.Expertise_HealthcareRegulatoryAndCompliance]: "Expertise",
  [SkillGroup.Activities_IPLicensing]: "Activities",
  [SkillGroup.IPType_IPLicensing]: "IP Type",
  [SkillGroup.Activities_InvestigationsAndEnforcement]: "Activities",
};
